import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "schedule-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "schedule-header-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Lista de Contatos")
], -1)
const _hoisted_3 = { class: "schedule-header-search" }
const _hoisted_4 = { class: "schedule-content" }
const _hoisted_5 = {
  key: 0,
  style: {"padding":"16px"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "schedule-footer" }
const _hoisted_8 = { class: "schedule-footer-left" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Novo Contato")
const _hoisted_10 = { class: "schedule-footer-right" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Adicionar no envelope")
const _hoisted_13 = { class: "schedule-actions" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h1", null, "Dados do Contato", -1)
const _hoisted_15 = { class: "action-name" }
const _hoisted_16 = { class: "action-channels" }
const _hoisted_17 = {
  key: 0,
  class: "channel-email"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("E-mail")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Whatsapp")
const _hoisted_20 = {
  key: 1,
  class: "channel-phone"
}
const _hoisted_21 = ["value", "selected"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("E-mail")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Whatsapp")
const _hoisted_25 = { class: "action-docs" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("CPF")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("RG")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("OUTRO")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("CPF")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("RG")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("OUTRO")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_HomeSchedule = _resolveComponent("HomeSchedule")!
  const _component_UserAddOutlined = _resolveComponent("UserAddOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_component_a_input_search, {
          value: _ctx.valueSearch,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.valueSearch) = $event)),
          placeholder: "Informe um termo para buscar na lista de contatos",
          "enter-button": "",
          onSearch: _ctx.onSearch,
          "allow-clear": ""
        }, null, 8, ["value", "onSearch"])
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_a_skeleton, {
              active: "",
              paragraph: { rows: 6 },
              style: {"width":"100%"}
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_HomeSchedule, {
              onCreateOrEdit: _ctx.createOrEdit,
              onContactsToEnvelope: _ctx.contactsToEnvelope,
              onSetTabIndex: _ctx.setTabIndex
            }, null, 8, ["onCreateOrEdit", "onContactsToEnvelope", "onSetTabIndex"])
          ]))
    ]),
    _createElementVNode("footer", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_a_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createOrEdit(null, false)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UserAddOutlined),
            _hoisted_9
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_a_button, {
          class: "cancel-schedule",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('isCloseModal')))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "add-schedule-envelope",
          type: "primary",
          onClick: _ctx.addContactsToEnvelope
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.isCreateOrEdit,
      "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.isCreateOrEdit) = $event)),
      closable: false,
      centered: "",
      okText: "Salvar na Agenda",
      cancelText: "Cancelar",
      onOk: _ctx.saveSchedule
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_a_input, {
              value: _ctx.formSchedule.PartName,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formSchedule.PartName) = $event)),
              placeholder: "Nome completo conforme o documento"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (!_ctx.formSchedule.isWhatsapp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_a_input, {
                    value: _ctx.formSchedule.Email,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formSchedule.Email) = $event)),
                    placeholder: "Digite um e-mail válido",
                    class: "input-email"
                  }, {
                    addonAfter: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.formSchedule.isWhatsapp,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formSchedule.isWhatsapp) = $event)),
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeTypeChannelSchedule())),
                        class: "change-channel"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: false }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: true }, {
                            default: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.formSchedule.isWhatsapp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["flag", _ctx.formSchedule.PhoneFlag])
                  }, null, 2),
                  (_ctx.formSchedule.isWhatsapp)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        class: "select-countries",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formSchedule.PhoneCode) = $event)),
                        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeCountryWhatsSchedule()))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countriesWhatsapp, (country) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: country.ddi,
                            key: country.sigla,
                            selected: country.sigla == 'BR'
                          }, _toDisplayString(country.name), 9, _hoisted_21))
                        }), 128))
                      ], 544)), [
                        [_vModelSelect, _ctx.formSchedule.PhoneCode]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.formSchedule.isWhatsapp)
                    ? _withDirectives((_openBlock(), _createBlock(_component_a_input, {
                        key: 1,
                        value: _ctx.formSchedule.Phone,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formSchedule.Phone) = $event)),
                        class: "input-phone"
                      }, {
                        addonBefore: _withCtx(() => [
                          (_ctx.formSchedule.PhoneCode != '')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.formSchedule.PhoneCode), 1))
                            : _createCommentVNode("", true)
                        ]),
                        addonAfter: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: _ctx.formSchedule.isWhatsapp,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formSchedule.isWhatsapp) = $event)),
                            onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeTypeChannelSchedule())),
                            class: "change-channel"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: false }, {
                                default: _withCtx(() => [
                                  _hoisted_23
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: true }, {
                                default: _withCtx(() => [
                                  _hoisted_24
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["value"])), [
                        [_directive_maska, _ctx.formSchedule.PhoneMask]
                      ])
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            (_ctx.formSchedule.isDocCPF)
              ? _withDirectives((_openBlock(), _createBlock(_component_a_input, {
                  key: 0,
                  value: _ctx.formSchedule.Document,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formSchedule.Document) = $event)),
                  placeholder: "Preencha o número do documento",
                  class: "input-doc",
                  onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.validateCPF(_ctx.formSchedule.Document, _ctx.formSchedule.isDocCPF, true)))
                }, {
                  addonAfter: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.formSchedule.DocumentType,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formSchedule.DocumentType) = $event)),
                      onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeTypeDocSchedule())),
                      class: "change-doc"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: "CPF" }, {
                          default: _withCtx(() => [
                            _hoisted_26
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "RG" }, {
                          default: _withCtx(() => [
                            _hoisted_27
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "OTHER" }, {
                          default: _withCtx(() => [
                            _hoisted_28
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["value"])), [
                  [_directive_maska, _ctx.formSchedule.docMask]
                ])
              : _createCommentVNode("", true),
            (_ctx.formSchedule.isDocRG || _ctx.formSchedule.isDocOther)
              ? (_openBlock(), _createBlock(_component_a_input, {
                  key: 1,
                  value: _ctx.formSchedule.Document,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formSchedule.Document) = $event)),
                  placeholder: "Preencha o número do documento",
                  class: "input-doc"
                }, {
                  addonAfter: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.formSchedule.DocumentType,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formSchedule.DocumentType) = $event)),
                      onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.changeTypeDocSchedule())),
                      class: "change-doc"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: "CPF" }, {
                          default: _withCtx(() => [
                            _hoisted_29
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "RG" }, {
                          default: _withCtx(() => [
                            _hoisted_30
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "OTHER" }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["value"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ], 64))
}